var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcPaymentSdk = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SDK",
    clipPath: "url(#clip0_12058_106268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86816 2.66797C5.21131 2.66797 3.86816 4.01111 3.86816 5.66796V14.3568L11.9995 16.8979L20.1309 14.3568V5.66797C20.1309 4.01111 18.7878 2.66797 17.1309 2.66797H6.86816ZM7.45301 11.5655C7.16231 11.5655 6.90182 11.5183 6.67153 11.424C6.44123 11.3296 6.25624 11.1899 6.11656 11.0049C5.98065 10.8199 5.90892 10.5972 5.90137 10.3367H6.93202C6.94712 10.4839 6.99809 10.5972 7.08492 10.6765C7.17175 10.752 7.28501 10.7897 7.42469 10.7897C7.56816 10.7897 7.68141 10.7576 7.76447 10.6934C7.84753 10.6255 7.88905 10.533 7.88905 10.416C7.88905 10.3178 7.85508 10.2366 7.78712 10.1725C7.72294 10.1083 7.64177 10.0554 7.54362 10.0139C7.44923 9.97237 7.31332 9.92518 7.13589 9.87232C6.87917 9.79304 6.66964 9.71376 6.5073 9.63448C6.34496 9.5552 6.20528 9.43817 6.08824 9.28338C5.97121 9.12859 5.91269 8.92662 5.91269 8.67745C5.91269 8.30747 6.04672 8.01866 6.31476 7.81102C6.58281 7.5996 6.93202 7.4939 7.3624 7.4939C7.80033 7.4939 8.15332 7.5996 8.42137 7.81102C8.68941 8.01866 8.83288 8.30936 8.85175 8.68311H7.80411C7.79656 8.55475 7.74937 8.45471 7.66254 8.38298C7.57571 8.30747 7.46433 8.26972 7.32842 8.26972C7.21139 8.26972 7.11701 8.30181 7.04528 8.36599C6.97355 8.42639 6.93768 8.51511 6.93768 8.63214C6.93768 8.7605 6.99809 8.86055 7.1189 8.93228C7.23971 9.00401 7.42847 9.0814 7.68519 9.16446C7.94191 9.25129 8.14955 9.33435 8.30811 9.41363C8.47045 9.49291 8.61013 9.60806 8.72717 9.75907C8.8442 9.91008 8.90272 10.1045 8.90272 10.3423C8.90272 10.5689 8.8442 10.7746 8.72717 10.9596C8.61391 11.1446 8.4478 11.2918 8.22883 11.4013C8.00986 11.5108 7.75126 11.5655 7.45301 11.5655ZM11.4962 7.55053C11.9153 7.55053 12.2815 7.63358 12.5948 7.79969C12.9082 7.96581 13.1498 8.19987 13.3197 8.5019C13.4933 8.80014 13.5802 9.14558 13.5802 9.53821C13.5802 9.92707 13.4933 10.2725 13.3197 10.5745C13.1498 10.8766 12.9063 11.1106 12.5892 11.2767C12.2758 11.4428 11.9115 11.5259 11.4962 11.5259H10.0069V7.55053H11.4962ZM11.4339 10.6878C11.8001 10.6878 12.0852 10.5877 12.289 10.3877C12.4929 10.1876 12.5948 9.90442 12.5948 9.53821C12.5948 9.17201 12.4929 8.88698 12.289 8.68311C12.0852 8.47925 11.8001 8.37731 11.4339 8.37731H10.9752V10.6878H11.4339ZM15.5979 9.77039L16.9344 11.5259H18.1179L16.521 9.49857L18.0613 7.55053H16.923L15.5979 9.29471V7.55053H14.6295V11.5259H15.5979V9.77039Z",
    fill: "url(#paint0_linear_12058_106268)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3785",
    d: "M0.75 15.0929C0.750001 14.0618 1.76629 13.3382 2.74067 13.6754L11.5093 16.7107C11.8272 16.8208 12.1728 16.8208 12.4907 16.7107L21.2593 13.6754C22.2337 13.3382 23.25 14.0618 23.25 15.0929L23.25 19.4518C23.25 20.0911 22.8448 20.6602 22.2407 20.8693L12.4907 24.2443C12.1728 24.3543 11.8272 24.3543 11.5093 24.2443L1.75934 20.8693C1.1552 20.6602 0.75 20.0911 0.75 19.4518L0.75 15.0929Z",
    fill: "url(#paint1_linear_12058_106268)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12058_106268",
    x1: 11.9995,
    y1: 2.66797,
    x2: 11.9995,
    y2: 16.8979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#189EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3863D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12058_106268",
    x1: 12,
    y1: 12.9863,
    x2: 12,
    y2: 24.4141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7F741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECA25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12058_106268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.986328)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcPaymentSdk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_payment_sdk.6838f973382740c97b82987f7e30fac6.svg";